import PropTypes from 'prop-types';
import { Field as ReduxFormField } from 'redux-form';
import { Field as FinalFormField } from 'react-final-form';
import Control from '../Control';

export default function SelectField({ isReactFinalForm = false, ...props }) {
  const Field = isReactFinalForm ? FinalFormField : ReduxFormField;

  return <Field {...props} component={Control} />;
}

SelectField.propTypes = {
  isReactFinalForm: PropTypes.bool,
};
